module.exports = __webpack_public_path__ + "static/media/neck3.3060cdcc.png";